import { Vector2Utils } from '../../../Types/IVector2';
import { AStarPathfinder } from './AStarPathfinder';
var AstarGridGraph = (function () {
    function AstarGridGraph(width, height) {
        this.dirs = [
            Vector2Utils.create(1, 0),
            Vector2Utils.create(0, -1),
            Vector2Utils.create(-1, 0),
            Vector2Utils.create(0, 1)
        ];
        this.walls = [];
        this.weightedNodes = [];
        this.defaultWeight = 1;
        this.weightedNodeWeight = 5;
        this._neighbors = new Array(4);
        this._wallsSet = new Set();
        this._weightedNodesSet = new Set();
        this._wallsDirty = true;
        this._weightedNodesDirty = true;
        this._width = width;
        this._height = height;
    }
    AstarGridGraph.prototype.addWall = function (wall) {
        this.walls.push(wall);
        this._wallsDirty = true;
    };
    AstarGridGraph.prototype.addWalls = function (walls) {
        var _a;
        (_a = this.walls).push.apply(_a, walls);
        this._wallsDirty = true;
    };
    AstarGridGraph.prototype.clearWalls = function () {
        this.walls.length = 0;
        this._wallsSet.clear();
        this._wallsDirty = false;
    };
    AstarGridGraph.prototype.addWeightedNode = function (node) {
        this.weightedNodes.push(node);
        this._weightedNodesDirty = true;
    };
    AstarGridGraph.prototype.addWeightedNodes = function (nodes) {
        var _a;
        (_a = this.weightedNodes).push.apply(_a, nodes);
        this._weightedNodesDirty = true;
    };
    AstarGridGraph.prototype.clearWeightedNodes = function () {
        this.weightedNodes.length = 0;
        this._weightedNodesSet.clear();
        this._weightedNodesDirty = false;
    };
    AstarGridGraph.prototype._updateHashSets = function () {
        if (this._wallsDirty) {
            this._wallsSet.clear();
            for (var _i = 0, _a = this.walls; _i < _a.length; _i++) {
                var wall = _a[_i];
                this._wallsSet.add(Vector2Utils.toHash(wall));
            }
            this._wallsDirty = false;
        }
        if (this._weightedNodesDirty) {
            this._weightedNodesSet.clear();
            for (var _b = 0, _c = this.weightedNodes; _b < _c.length; _b++) {
                var node = _c[_b];
                this._weightedNodesSet.add(Vector2Utils.toHash(node));
            }
            this._weightedNodesDirty = false;
        }
    };
    AstarGridGraph.prototype.isNodeInBounds = function (node) {
        return 0 <= node.x && node.x < this._width && 0 <= node.y && node.y < this._height;
    };
    AstarGridGraph.prototype.isNodePassable = function (node) {
        this._updateHashSets();
        return !this._wallsSet.has(Vector2Utils.toHash(node));
    };
    AstarGridGraph.prototype.search = function (start, goal) {
        return AStarPathfinder.hasPath(this, start, goal);
    };
    AstarGridGraph.prototype.searchPath = function (start, goal) {
        return AStarPathfinder.searchPath(this, start, goal);
    };
    AstarGridGraph.prototype.getNeighbors = function (node) {
        this._neighbors.length = 0;
        for (var _i = 0, _a = this.dirs; _i < _a.length; _i++) {
            var dir = _a[_i];
            var next = Vector2Utils.add(node, dir);
            if (this.isNodeInBounds(next) && this.isNodePassable(next)) {
                this._neighbors.push(next);
            }
        }
        return this._neighbors;
    };
    AstarGridGraph.prototype.cost = function (from, to) {
        this._updateHashSets();
        return this._weightedNodesSet.has(Vector2Utils.toHash(to)) ? this.weightedNodeWeight : this.defaultWeight;
    };
    AstarGridGraph.prototype.heuristic = function (node, goal) {
        return Vector2Utils.manhattanDistance(node, goal);
    };
    AstarGridGraph.prototype.getStats = function () {
        this._updateHashSets();
        return {
            walls: this.walls.length,
            weightedNodes: this.weightedNodes.length,
            gridSize: "".concat(this._width, "x").concat(this._height),
            wallsSetSize: this._wallsSet.size,
            weightedNodesSetSize: this._weightedNodesSet.size
        };
    };
    return AstarGridGraph;
}());
export { AstarGridGraph };
